<template>
  <b-table 
    :items="aspecten" 
    :fields="aspectFields" 
    :caption="aspectFields.map(a => a.key).join()"
  >
    <template #cell(text)="row">
      <b-input-group :prepend="row.item.value.toString()">
        <b-input 
          v-model="row.item.text" 
          @input="updateMatrix"
        />
      </b-input-group>
    </template>
    <template #cell()="row">
      <b-check 
        v-model="row.item.prioriteiten" 
        :value="Number(row.field.label)" 
        @change="updateMatrix"
      />
    </template>
    <template #cell(slider)="row">
      <b-checkbox-group 
        v-model="row.item.prioriteiten" 
        :options="[1,2,3,4,5,6,7,8,9]" 
        button-variant="outline-secondary" 
        buttons 
        @change="updateMatrix"
      />
    </template>
    <template #footer()>
      <b-button>Opslaan</b-button>
    </template>
  </b-table>
</template>
<script>
export default {
    name: 'AspectPrioriteitMatrix',
    props: {
        aspecten: {
            type: Array,
            default: () => [
                {value:1,text:'Veiligheid/gezondheid',prioriteiten:[1,2,3]},
                {value:2,text:'Cultuurhistorische waarde',prioriteiten:[2,3,4]},
                {value:3,text:'Gebruik en bedrijfsproces',prioriteiten:[3,4,5]},
                {value:4,text:'Technische vervolgschade',prioriteiten:[4,5,6]},
                {value:5,text:'Toename klachtenonderhoud',prioriteiten:[5,6,7]},
                {value:6,text:'Beleving esthetica',prioriteiten:[7,8,9]},
                {value:7,text:'Duurzaamheid',prioriteiten:[6,7,8]}
            ],
        }
    },
    data() {
        return {
            slider: true
        }
    },
    computed : {
        aspectFields: function() {
            if (this.slider) return [{key:'text',label:'Aspect'},{key:'slider',label:'Prioriteit'}]
            return [{key:'text',label:'Aspect'}].concat([1,2,3,4,5,6,7,8,9].map(n => { return { key: `col-${n}`, label:n.toString() }}));
        }
    },
    watch: {
        aspecten: function(n) {
            console.log(n)
        }
    },
    methods: {
        updateMatrix() {
            console.log('update');
            this.$emit('on-update',this.aspecten);
        }
    },
}
</script>